import {
  Grid,
  Stack,
  Typography
} from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchSettings } from "../../lib/slices/settingSlice";
import { createBasePackage, generateBasePackageSpecification, getBasePackageById, updateBasePackage } from "../../services/basePackagesFn";
import { getAllEcomCategory } from "../../services/ecomCategoryApiFn";
import { getAllEcommerceTags } from "../../services/ecommerceTageApiFn";
import { getAllEcomSubCategory } from "../../services/ecomSubCategoryApiFn";
import { getAllEcomSubSubCategory } from "../../services/ecomSubSubCategoryApiFn";
import {
  decodeHtml,
  handleOpenSnackBar
} from "../../utils";
import { translateText } from "../../utils/translationService";
import { addEditBasePackageValidation } from "../../utils/Validation";
import AppLoader from "../AppLoader/index";
import BasePackageSelectedCards from "../Cards/BasePackageSelectedCards";
import PaperContainer from "../Containers/PaperContainer";
import GlobalButton from "../CustomButton";
import BasicInformation from "./BasicInformation";
import AllProducts from "./Products";
import SpecificationAndDescription from "./Specification&Description";
import Tags from "./Tags";
import { useTranslation } from "react-i18next";

const AddEditPackage = ({ handleChangeTab }) => {
  const errorRef = useRef(null);
  const dispatch = useDispatch();
  const { t } = useTranslation(["products", "common"]);
  const [type, setType] = useState("add")
  const [isLoading, setIsLoading] = useState({
    translateToEnglish: false,
    fetch: false,
    addUpdate: false,
    generateSpecification: false,
  });
  const [packageDetail, setPackageDetail] = useState(null);
  const [allCategories, setAllCategories] = useState([]);
  const [allSubCategories, setAllSubCategories] = useState([]);
  const [allSubSubCategories, setAllSubSubCategories] = useState([]);
  const [allEcommerceTags, setAllEcommerceTags] = useState([]);
  const [selectedPackageProduct, setSelectedPackageProduct] = useState([]);
  const [initialSelectedPackageProduct, setInitialSelectedPackageProduct] = useState([]);
  const [inputError, setInputError] = useState({});
  const [inputValues, setInputValues] = useState({
    name_en: "",
    name_ro: "",
    category: "",
    subCategory: "",
    subSubCategory: "",
    description_en: "",
    description_ro: "",
    specification_en: "",
    specification_ro: "",
    tags: [],
    solutionType: [],
  });

  const userData = useSelector((state) => state.userData.user);
  const settings = useSelector((state) => state.settingsReducer.settings);
  const { currentLanguage } = useSelector((state) => state.languageReducer);
  const basePackageId = useSelector(
    (state) => state.detailIdReducer?.detailIds.packageId
  );

  const fetchchedBasePackageDetail = async (id) => {
    try {
      setIsLoading((prev) => ({ ...prev, fetch: true }));
      const response = await getBasePackageById(id);
      if (response?.data?.status === "success") {
        const data = response?.data?.data;

        const getSelectedVariant = (variants, variantId) => {
          return variants.find((variant) => variant._id === variantId);
        }

        const mappedProducts = data?.products?.map((product) => ({
          ...product,
          ...(product.variantId && { variantId: product.variantId }),
          ...(product.variantId && { selectedVariant: getSelectedVariant(product.productId.variants, product.variantId) }),
          ...product.productId,
          productId: undefined,
        }));
        console.log(data, "casdlkasdkasdklsadklsadlkas");
        setPackageDetail(data);
        setSelectedPackageProduct(mappedProducts);
        setInitialSelectedPackageProduct(mappedProducts);

        fetchchedAllSubCategories(data.categoryId?._id);

        setInputValues((prev) => ({
          ...prev,
          name_en: data.name.en,
          name_ro: data.name.ro,
          category: data.categoryId?._id || "",
          description_en: data.description.en,
          description_ro: data.description.ro,
          specification_en: decodeHtml(data.specification.en),
          specification_ro: decodeHtml(data.specification.ro),
          tags: data.tags || [],
          solutionType: data?.solutionType || [],
        }));
      } else {
        handleOpenSnackBar(response?.data?.message, "error");
      }
    } catch (error) {
      handleOpenSnackBar(error?.message, "error");
    } finally {
      setIsLoading((prev) => ({ ...prev, fetch: false }));
    }
  };

  // Fetch all categories
  const fetchchedAllCategories = async () => {
    try {
      const response = await getAllEcomCategory();
      if (response?.data?.status === "success") {
        setAllCategories(response?.data?.data);
      } else {
        console.error(response?.data?.message);
      }
    } catch (error) {
      console.error(error);
    }
  };

  // Fetch all sub categories
  const fetchchedAllSubCategories = async (value) => {
    try {
      const response = await getAllEcomSubCategory("", value);
      if (response?.data?.status === "success") {
        setAllSubCategories(response?.data?.data);
      } else {
        console.error(response?.data?.message);
      }
    } catch (error) {
      console.error(error);
    }
  };

  // Fetch all sub sub categories
  const fetchchedAllSubSubCategories = async (value1, value2) => {
    try {
      const response = await getAllEcomSubSubCategory("", value1, value2);
      if (response?.data?.status === "success") {
        setAllSubSubCategories(response?.data?.data);
      } else {
        console.error(response?.data?.message);
      }
    } catch (error) {
      console.error(error);
    }
  };

  // Fetch all ecommerce tags
  const fetchchedAllEcommerceTags = async (solutionType) => {
    try {
      const params = {
        solutionType: solutionType,
        appliesTo: "package",
      };
      const response = await getAllEcommerceTags(params);
      if (response?.data?.status === "success") {
        const data = response?.data?.data
        const formattedData = data.map((item) => ({
          label: item.name,
          value: item._id,
        }));
        setAllEcommerceTags(formattedData);
      } else {
        handleOpenSnackBar("error", response?.data?.message);
      }
    } catch (error) {
      handleOpenSnackBar("error", error?.message);
    }
  };

  useEffect(() => {
    if (basePackageId) {
      setType("edit")
      fetchchedBasePackageDetail(basePackageId);
    }
  }, [basePackageId]);

  useEffect(() => {
    fetchchedAllCategories();
    dispatch(fetchSettings());
  }, []);

  useEffect(() => {
    fetchchedAllEcommerceTags(inputValues.solutionType);
  }, [inputValues.solutionType]);

  // Handle change input value
  const handleChangeInputValue = (event) => {
    const { name, value, type, valueAsNumber } = event.target;

    const finalValue = type === "number" ? valueAsNumber : value;

    // If category changes, fetch products for the new category
    if (name === "category") {
      fetchchedAllSubCategories(finalValue);
      setSelectedPackageProduct([]);
      setInputValues((val) => ({ ...val, subCategory: "", subSubCategory: "" }));
    }

    if (name === "subCategory" && inputValues.category) {
      fetchchedAllSubSubCategories(inputValues.category, finalValue);
    }

    if (name === "solutionType") {
      setSelectedPackageProduct([]);
      setInputValues((prev) => ({ ...prev, tags: [] }));
    }

    setInputValues((val) => ({ ...val, [name]: finalValue }));
    setInputError((err) => ({ ...err, [name]: "" }));
  };

  // Handle editor change
  const handleEditorChange = (key, html) => {
    setInputError((err) => ({ ...err, [key]: false }));
    setInputValues((val) => ({ ...val, [key]: html }));
  };


  // Handle translate to english
  const handleTranslateToEnglish = async (key1, key2) => {
    if (!inputValues[key1]) {
      return handleOpenSnackBar("error", t("validation.valueRequired"));
    }

    setIsLoading((prev) => ({ ...prev, translateToEnglish: true }));
    try {
      const [englishText] = await Promise.all([
        translateText(inputValues[key1]),
      ]);
      setInputValues((prev) => ({
        ...prev,
        [key2]: englishText,
      }));
      setInputError((prev) => ({
        ...prev,
        [key2]: "",
      }));
    } catch (error) {
      handleOpenSnackBar("error", t("error.errorWhileTranslating", { ns: "common" }));
    } finally {
      setIsLoading((prev) => ({ ...prev, translateToEnglish: false }));
    }
  };

  const getCartItemKey = (p) =>
    p?.variantId ? `${p._id}_${p.variantId}` : (p?._id ?? "");

  // Handle delete tag
  const handleDeleteTag = (tag) => {
    setInputValues((prev) => ({ ...prev, tags: prev.tags.filter((t) => t !== tag) }));
    setInputError((prev) => ({ ...prev, tags: "" }));
  };

  // Remove product from selected package products
  const handleRemoveSelectedProduct = (product) => {
    setSelectedPackageProduct((prev) => prev.filter((p) => p._id !== product._id));
  };

  const handleGenerateSpecification = async () => {
    if (!selectedPackageProduct.length) {
      return handleOpenSnackBar("error", t("validation.selectProducts"));
    }
    try {
      setIsLoading((prev) => ({ ...prev, generateSpecification: true }));
      const ids = selectedPackageProduct.map((product) => product._id);
      const response = await generateBasePackageSpecification({
        productIds: ids,
      });
      if (response?.data?.status === "success") {
        const data = response?.data?.data;
        setInputValues((prev) => ({
          ...prev,
          specification_en: data.en,
          specification_ro: data.ro
        }));
        handleOpenSnackBar("success", response?.data?.message);
      } else {
        handleOpenSnackBar("error", response?.data?.message);
      }
    } catch (error) {
      handleOpenSnackBar("error", error?.message);
    } finally {
      setIsLoading((prev) => ({ ...prev, generateSpecification: false }));
    }
  }

  // Scroll to error
  const scrollToError = () => {
    if (errorRef.current) {
      errorRef.current.scrollIntoView({
        behavior: "smooth",
        block: "center",
        inline: "nearest",
      });
      setTimeout(() => {
        if (errorRef.current) {
          errorRef.current.focus();
        }
      }, 300);
    }
  };


  // Handle add package
  const handleAddPackage = async () => {
    errorRef.current = null;

    const finalInputValue = {
      ...inputValues,
    };

    const validate = addEditBasePackageValidation(finalInputValue, setInputError, errorRef);

    if (validate) {
      scrollToError();
      return handleOpenSnackBar("error", t("resolveTheIssues", { ns: "common" }));
    }

    if (selectedPackageProduct.length < 2) {
      return handleOpenSnackBar("error", t("validation.selectAtLeastTwoProducts"));
    }

    const extractSubCategoryId = selectedPackageProduct.flatMap((product) =>
      Array.isArray(product.subCategory || product.subCategoryId)
        ? (product.subCategory || product.subCategoryId).map((sub) => sub?._id).filter(Boolean)
        : []
    );

    const extractSubSubCategoryId = selectedPackageProduct.flatMap((product) =>
      Array.isArray(product.subSubCategory || product.subSubCategoryId)
        ? (product.subSubCategory || product.subSubCategoryId).map((sub) => sub?._id).filter(Boolean)
        : []
    );

    const uniqueSubCategoryIds = Array.from(new Set(extractSubCategoryId));
    const uniqueSubSubCategoryIds = Array.from(new Set(extractSubSubCategoryId));

    const selectedProductsIds = selectedPackageProduct.map((product) => {
      return {
        productId: product._id,
        selectedQty: product.selectedQty,
        ...(product.variantId && { variantId: product.variantId }),
      };
    });

    const allImages = selectedPackageProduct.map((x) => x.selectedVariant?.images?.length > 0 ? x.selectedVariant?.images[0] : x.coverImage);

    const payload = {
      images: allImages,
      name: { en: inputValues.name_en, ro: inputValues.name_ro },
      description: {
        en: inputValues.description_en,
        ro: inputValues.description_ro,
      },
      specification: {
        en: inputValues.specification_en,
        ro: inputValues.specification_ro,
      },
      categoryId: inputValues.category,
      subCategoryId: uniqueSubCategoryIds,
      subSubCategoryId: uniqueSubSubCategoryIds,
      // createdBy: userData?.adminId,
      tags: inputValues.tags,
      solutionType: inputValues.solutionType,
      products: selectedProductsIds,
    };

    let updatePayload = payload;
    if (type === "edit") {
      const initialImages = initialSelectedPackageProduct.map((x) =>
        x.selectedVariant?.images?.length > 0 ? x.selectedVariant?.images[0] : x.coverImage
      );
      const isImageUpdated = JSON.stringify(initialImages) !== JSON.stringify(allImages);
      if (!isImageUpdated) {
        updatePayload = { ...payload };
        delete updatePayload.images;
      }
    }

    try {
      setIsLoading((prev) => ({ ...prev, addUpdate: true }));
      let response;
      if (type === "add") {
        response = await createBasePackage(payload);
      } else {
        response = await updateBasePackage(basePackageId, updatePayload);
      }
      if (response?.data.status === "success") {
        handleOpenSnackBar("success", response?.data.message);
        handleChangeTab("base_packages_list");
      } else {
        handleOpenSnackBar("error", response?.data?.message);
      }
    } catch (error) {
      handleOpenSnackBar("error", error?.message);
    } finally {
      setIsLoading((prev) => ({ ...prev, addUpdate: false }));
    }
  };

  return (
    <>
      <AppLoader isVisible={isLoading.addUpdate || isLoading.fetch} />
      <PaperContainer
        title={type === "add" ? t("addNewPackage") : t("editPackage")}
        subtitle={type === "add" ? t("provideRequiredDetailsForAdd") : t("provideRequiredDetailsForEdit")}
        showBackButton={true}
        onBack={() => handleChangeTab("base_packages_list")}
      >
        <BasicInformation
          isLoading={isLoading}
          inputValues={inputValues}
          inputError={inputError}
          allCategories={allCategories}
          allSubCategories={allSubCategories}
          allSubSubCategories={allSubSubCategories}
          handleChangeValues={handleChangeInputValue}
          handleTranslateToEnglish={handleTranslateToEnglish}
        />

        <AllProducts
          packageDetail={packageDetail}
          inputValues={inputValues}
          selectedProducts={selectedPackageProduct}
          setSelectedProducts={setSelectedPackageProduct}
        />

        {selectedPackageProduct.length > 0 && (
          <>
            <Typography fontWeight={600} fontSize={20}>
              {t("selectedProducts")}
            </Typography>
            <Grid container spacing={2} mt={2}>
              {selectedPackageProduct.map((product) => (
                <Grid item xs={12} sm={4} md={3} key={getCartItemKey(product)}>
                  <BasePackageSelectedCards
                    cardData={product}
                    onDelete={handleRemoveSelectedProduct}
                  />
                </Grid>
              ))}
            </Grid>
          </>
        )}

        <Tags
          inputValues={inputValues}
          inputError={inputError}
          handleChangeInputValue={handleChangeInputValue}
          handleDeleteTag={handleDeleteTag}
          allEcommerceTags={allEcommerceTags}
        />

        <SpecificationAndDescription
          inputValues={inputValues}
          inputError={inputError}
          handleChangeValues={handleChangeInputValue}
          handleEditorChange={handleEditorChange}
          handleTranslateToEnglish={handleTranslateToEnglish}
          isLoading={isLoading}
          handleGenerateSpecification={handleGenerateSpecification}
        />


        <Stack
          mt={10}
          mb={3}
          direction={"row"}
          alignItems={"center"}
          justifyContent={"flex-end"}
        >
          <Stack minWidth={120} height={40} mr={2}>
            <GlobalButton
              btnText={"discard"}
              styleProps={{
                backgroundColor: "#FFF",
                color: "primary.main",
              }}
              hoverProperties={{
                color: "primary.main",
                backgroundColor: "#FFF",
              }}
              handleClickBtn={() => handleChangeTab("base_packages_list")}
            />
          </Stack>
          <Stack minWidth={120} height={40}>
            <GlobalButton btnText={type === "add" ? t("save") : t("update")} handleClickBtn={handleAddPackage} />
          </Stack>
        </Stack>
      </PaperContainer>
    </>
  );
};

export default AddEditPackage;
